import { queryOptions, skipToken } from '@tanstack/react-query'

import { getMenuProductRatings } from '../service/combinedapi/menuProductRatings'

export const menuProductRatingQueries = {
  list: ({ menuID, userID }: { menuID: string | undefined; userID: number }) =>
    queryOptions({
      queryKey: ['menuProductRatings', menuID, userID],
      queryFn: menuID
        ? () => getMenuProductRatings({ menuID, userID })
        : skipToken,
    }),
}
